import { QuizService } from "@/common/api.service"
import { FETCH_QUIZ, FETCH_INDIVIDUAL_QUIZ, ADD_QUIZ, UPDATE_QUIZ, DELETE_QUIZ, RESET_STATE} from "./actions.type"
import { SET_QUIZ, SET_INDIVIDUAL_QUIZ, SET_ERROR_QUIZ, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        quizzes: [],
        individualquiz: [],
        quizerrors: null,
    }
}

let state = initialState()

const getters = {
    quizzes(state) {
        return state.quizzes
    },
    individualquiz(state) {
        return state.individualquiz
    }
}

const actions = {
    async [FETCH_QUIZ](context, slug) {
        const { data } = await QuizService.get(slug)
        context.commit(SET_QUIZ, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_QUIZ](context, slug) {
        const { data } = await QuizService.get(slug)
        context.commit(SET_INDIVIDUAL_QUIZ, data.data)
        return data;
    },  
    async [ADD_QUIZ](context, payload) {
        return await QuizService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUIZ, error.response.data.errors)
        });
    },     
    async [UPDATE_QUIZ](context, payload) {
        return await QuizService.update(payload, payload.get('quiz_id'))
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUIZ, error.response.data.errors)
        });
    },  
    async [DELETE_QUIZ] (context, id) {
        return await QuizService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUIZ, error.response.data.errors)
        });
    },  
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_QUIZ](state, error) {
        state.quizerrors = error
    },      
    [SET_QUIZ](state, quizdata) {
        state.quizzes = quizdata
    },
    [SET_INDIVIDUAL_QUIZ](state, individualquiz) {
        state.individualquiz = individualquiz
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};